import SinglePropChainTracker from "../../../prop-tracker-utils/single-prop-chain-tracker.js";

import CameraTrackerController from "./camera/camera-tracker-controller.js";

class CameraProperties {
    constructor(wrapCtx, evtCtx, cameraController) {
        this._evtCtx = evtCtx;
        this._camDataTracker = new SinglePropChainTracker(evtCtx);
        this._camTrackCtrl = new CameraTrackerController(wrapCtx, evtCtx, cameraController);
    }

    track(camera) {
        if (camera) {
            this._camDataTracker.track(camera.data, ["value"]);
        } else {
            this._camDataTracker.track();
        }
    }

    update() {
        this._camDataTracker.updateIfNeeded(({ prop: { newValue } }) => {
            this._camTrackCtrl.track(newValue, newValue ? this._evtCtx.getEvents(newValue) : null);
        });

        this._camTrackCtrl.update();
    }
}

export default CameraProperties;
